import { getOwnerId } from "../../../core/game/common/ReplicatedData";
import { ReplicatedAction } from "../../../core/game/interfaces/ReplicatedAction";
import { isValidEnglishWord } from "../util/Word";
function SetSecretWordValidator(data, context) {
    if (!isValidEnglishWord(data.secretWord)) {
        return `Secret words must be valid English words!`;
    }
    if (/[^a-zA-Z0-9]/.test(data.secretWord)) {
        return `Secret words must be one word and contain only letters and numbers!`;
    }
    return data.secretWord.length > 0 && getOwnerId(data) === context.gameState.secretWordGiverId;
}
function SetSecretWordEffect(data, context) {
    context.gameState.commitData({
        secretWord: data.secretWord,
    });
}
export const SetSecretWord = new ReplicatedAction('SetSecretWord', SetSecretWordValidator, SetSecretWordEffect);
//# sourceMappingURL=SetSecretWord.js.map